import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

export const digitapIncomeUpdateStatus = async (params) => {
  try {
    const response = await apiClient.get(ENDPOINTS.DIGITAP_INCOME_UPDATE_STATUS, {
      params,
    });
    return unwrapApiResponse(response, {
      extract: "results",
      fallbackMessage: "Failed to update income verification status",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
